import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';

function SearchInput({
  value,
  onChange,
  placeholder,
  className = '',
  'aria-label': ariaLabel,
  onClear,
  clearLabel,
}) {
  const { t } = useLanguage();
  const showClear = Boolean(value?.length);
  const resolvedClear = clearLabel || t.common?.clearSearch || 'Clear search';

  return (
    <div className={`ios-search-wrap ${className}`.trim()}>
      <MagnifyingGlassIcon className="ios-search-icon pointer-events-none" aria-hidden="true" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder || t.common?.search}
        className="ios-search-input"
      />
      {showClear ? (
        <button
          type="button"
          onClick={() => (onClear ? onClear() : onChange(''))}
          className="ios-search-clear"
          aria-label={resolvedClear}
        >
          <XMarkIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}

export default SearchInput;
